
import { i18nText } from '@/locales';
import dayjs from "dayjs";
import { VisitsStore } from "@/store/modules/Visits";
import { dragEventI, RecordDataForm, ServiceData } from "@/form/visits/New/Record";
import { AppStateStore } from "@/store/modules/appState";
import Vue from "vue";
import { RouterNameEnum } from "@/router/router.types";
import {showNotificationSimple, showSimpleMessage} from "@/UI/lib/messages";
import { ServiceStore } from "@/store/modules/Services";
import { calendarEventT, MoveVisit } from "@/UI/pages/visitsNew/Lib/visitTypes";
import { parseDateFormatted } from "@/UI/lib/parseSupport";
import { DateTime, Interval } from "ts-luxon";

export function getVisitId(): number {
    return Number(Vue.router.currentRoute.params["id"]);
}
export function RecordParamsEvent(): any {
    // TODO: this should be JSON.parse(Vue.router.currentRoute.params.params)[" smthing...
    // return JSON.parse(Vue.router.currentRoute.params.params);
    if (Vue.router.currentRoute.params["event"] === undefined) {
        return undefined;
    }
    else {
        return JSON.parse(Vue.router.currentRoute.params["event"]);
    }
}
export function RecordParams():any {
    return Vue.router.currentRoute.params;
}
export function RecordParamsData(): any {
    return JSON.parse(Vue.router.currentRoute.params["params"]);
}

export async function parseVisitsData(
    date_from: string,
    date_to: string,
    vStore: typeof VisitsStore,
    studioId: number,
): Promise<void> {
    //TODO::Решить вопрос c limit:1000
    await vStore.fetchAll({
        limit: 50,
        filter: { visit_dt_from: date_from, visit_dt_to: date_to, salon_id: studioId },
    });
}
export async function parseVisitsCurrentData(date: any, studioId: number, vStore: typeof VisitsStore): Promise<void> {
    if (!date) {
        await parseVisitsData(dayjs().format("DD.MM.YYYY"), dayjs().format("DD.MM.YYYY"), vStore, studioId);
    } else {
        const dateWork = new Date(Number(date));
        const dta = dateWork.toDateString();
        const wDate = dayjs(dta).format("DD.MM.YYYY");
        await parseVisitsData(wDate, wDate, vStore, studioId);
    }
}
export function isTimeIntervalAvailable(events: calendarEventT[], eventD: dragEventI): boolean {
    let result = false;
    const times: any[] = [];
    events.map((event: calendarEventT) => {
        try {
            if (
                Number(event.visitData?.status_id) !== 5 &&
                event.id !== eventD.vData.id &&
                event.visitData !== undefined &&
                eventD.vData.cosmetologists_id !== undefined
            ) {
                if (Number(event.visitData.cosmetologists_id) === Number(eventD.vData.cosmetologists_id)) {
                    const start = parseDateFormatted(String(event.start).replace(" ", ",")),
                        end = parseDateFormatted(String(event.end).replace(" ", ","));

                    if (start !== null && end !== null) {
                        let startDate = DateTime.now(),
                            endDate = DateTime.now();

                        startDate = startDate.set({
                            hours: start.hours,
                            minutes: start.minutes,
                            years: start.year,
                            month: start.month,
                            day: start.day,
                        });

                        endDate = endDate.set({
                            hours: end.hours,
                            minutes: end.minutes,
                            years: end.year,
                            month: end.month,
                            day: end.day,
                        });

                        times.push({ start: startDate, end: endDate });
                    }
                }
            }
            times.map((tm: any) => {
                //const interval = Interval.fromDateTimes(eventD.time.start, eventD.time.end);
                const interval = Interval.fromDateTimes(tm.start, tm.end);
                if (interval.contains(eventD.time.start) && interval.contains(eventD.time.end)) {
                    result = true;
                }
            });
        } catch (e) {
            console.log("isTimeIntervalAvailable error :" + e);
            console.error(e);
        }
    });
    return result;
}
export async function moveVisitAction(
    id: number,
    data: MoveVisit,
    events: calendarEventT[],
    store: typeof VisitsStore,
): Promise<void> {
    //await this.parseVisit(id);
    const form = new RecordDataForm();
    const event = events.find((event: calendarEventT) => event.id === id);
    if (event) {
        await form.parseVisitData(event.visitData);
        form.cosmetologists_id = data.category.toCategory;
        //await form.parseDuration(false, form.visit_date + "," + data.times.time.time);
        await form.parseDuration(false, event.start);
        store.updateNew(form).then((response) => {
            if(response) {
                if(response.status) {
                    showNotificationSimple(i18nText("Успешно"), response.response, 10);
                } else {
                    showNotificationSimple(i18nText("Ошибка"), response.response, 10);
                }
            }
        });
    }
}
export async function checkFormServiceDataNew(form: RecordDataForm, store: any): Promise<void> {
    if (form.service_data) {
        form.service_data.map(async (service: ServiceData) => {
            if (
                store.state["services"]["service"]["data"].filter((value: any) => value.id === service["service_id"])
                    .length === 0
            ) {
                try {
                    await ServiceStore.fetchData({ filter: { id: service["service_id"] } });
                } catch (e) {
                    showNotificationSimple(i18nText("ошибка получения данных услуг"), "", 1);
                } finally {
                    await ServiceStore.add(store.state["services"]["services"]);
                }
            }
        });
    }
}

export function newVisitS(): boolean {
    return Number(Vue.router.currentRoute.params["id"]) === 0;
}
export async function getVisitData(id?: number, store?: typeof VisitsStore): Promise<void> {
    // try {
        await store?.fetchData({ filter: { id: id } });
    //     alert('ok')
    // } catch (e) {
    //     alert('no ok')
    //     console.log("Parse Visit Data Error ID - " + id);
    // }
}
export async function updateVisitData(
    value: boolean,
    form: RecordDataForm,
    RecordParams: any,
    noRoute: boolean,
    vStore: typeof VisitsStore,
    appStateStore: typeof AppStateStore,
    newVisit: boolean,
    studioId: number,
    route?: any,
    route_name?: any
): Promise<void> {
    if (value) {
        appStateStore.setSubmit(false);
        if (!newVisit) {
            //this.form.visit_date = null;
            await vStore.updateNew(form).then(async (response:any) => {
                if (response["status"]) {
                    appStateStore.setSuccess(true);
                    if (!noRoute)
                        await Vue.router.push({
                            name: RouterNameEnum.VisitsNewStatusFm,
                            params: {
                                id: String(form.id),
                                params: JSON.stringify(form),
                                event: JSON.stringify(form),
                                isNew: "0",
                            },
                        });
                } else {
                    showNotificationSimple(i18nText(" Ошибка обновления  визита -"), response.response, 2);
                    if(response['errors'] && response['errors'].length) {
                        for (let i = 0; i < response['errors'].length; i++) {
                            showSimpleMessage(response['errors'][i], 'error');
                        }
                    }
                    //console.log(" Ошибка обновления  визита -"+ response.response);
                }
            });
        } else {
            form.new_client = form.client_id === 0;
            await vStore.createNew(form).then(async (response) => {
                if (response["status"]) {
                    appStateStore.setSuccess(true);
                    if (!noRoute)
                        await Vue.router.push({
                            name: RouterNameEnum.VisitsNewStatusFm,
                            params: {
                                id: String(response["id"]),
                                params: JSON.stringify(form),
                                event: JSON.stringify(form),
                                isNew:"1",
                            },
                        });

                    if (route) {
                        setTimeout( async () => {
                            await Vue.router.push({
                                name: route_name,
                                params: { id: String(response["id"]) },
                            });
                        }, 1000)
                    }
                    /*
                        await Vue.router.push({
                            name: RouterNameEnum.VisitsNewStatus,
                            params: {
                                Studio: String(studioId),
                                Worker: Vue.router.currentRoute.params["Worker"],
                                params: JSON.stringify(RecordParams),
                                id: String(response["id"]),
                                mode: "status",
                            },
                        });*/
                } else {
                    showNotificationSimple(i18nText(" Ошибка визита -"), response.response, 10);
                    if (response['errors'] && response['errors'].length) {
                        for (let i = 0; i < response['errors'].length; i++) {
                            showSimpleMessage(response['errors']?.[i], 'error');
                        }
                    }
                    //console.log(" Ошибка визита -"+ response.response);
                }
            });
        }
    }
}

export function genDate(dt: Date, tm: string | null): any {
    const tmm = tm?.split(":");
    let hour = 0,
        minute = 0;
    if (tmm) {
        hour = Number(tmm[0]);
        minute = Number(tmm[1]);
    }
    return dayjs(dt).set("hour", hour).set("minute", minute).utc(true).format("YYYY-MM-DD HH:mm");
}

export function genTime(hours: number, minutes: number): string {
    let hr = String(hours);
    let mn = String(minutes);
    if (hr.length === 1) hr = "0" + hr;
    if (mn.length === 1) mn = "0" + mn;
    return hr + ":" + mn;
}
